import { render, staticRenderFns } from "./robotTalk.vue?vue&type=template&id=9b8a541a&"
import script from "./robotTalk.vue?vue&type=script&lang=js&"
export * from "./robotTalk.vue?vue&type=script&lang=js&"
import style0 from "./robotTalk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports